import React from "react";
import Subheader from "@components/Subheader/Subheader";
import MovementServices from "@features/movement-services/grid/MovementServices.tsx";
import PageLayout from "@layouts/PageLayout";
import { useTranslation } from "react-i18next";

const LANG_BASE = "movement-services";
const TEST_ID_BASE = "movement-services-page";

const MovementServicesContainer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <PageLayout dir={dir}>
      <Subheader
        testId={`${TEST_ID_BASE}-subheader`}
        subtitle={t("navigation.vessel-call")}
        title={
          <div className="flex items-end justify-between w-full">
            <span>{t(`${LANG_BASE}.title`)}</span>
          </div>
        }
      />
      <div className="pt-8 pb-8 px-24 flex flex-col gap-6">
        <MovementServices />
      </div>
    </PageLayout>
  );
};

export default MovementServicesContainer;
